import React from 'react'
import { connect } from 'react-redux'
import MediaQuery from 'react-responsive'
import { Link, browserHistory } from 'react-router'
import { setUsername } from '../../actions/users'
import Face from './homepage_face.png'
import Title from './homepage_title.png'
import Bubble from './homepage_bubble.png'
import classes from './Homepage.scss'
import Overlay from '../../components/Overlay'
import 'whatwg-fetch'

class Homepage extends React.Component {
  
  constructor (props) {
    super(props)
    const { setUsername } = props

    const baseUrl = process.env.NODE_ENV === 'production' ? 'https://api.mrjotto.com' : 'http://localhost:3000'
    this.state = { baseUrl }
    // load the user
    fetch(`${baseUrl}/user/info`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          setUsername(res.msg)
        }
      })
    const self: any = this
    self.logout = self.logout.bind(self)
  }

  logout () {
    const { baseUrl } = this.state
    const { setUsername } = this.props

    fetch(`${baseUrl}/logout`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          setUsername('')
          browserHistory.push('/')
        }
      })
  }

  render () {
    const { username } = this.props
    const versusClass = !username && classes.disabled
    return (
      <div className={classes.main}>
        <img src={Title} className={classes.titleImage} />
        <div><img src={Face} className={classes.faceImage} /></div>
        <MediaQuery component={'img'} src={Bubble} className={classes.bubble} minWidth={970} />
        <span className={classes.welcomeText}>Welcome,<br /><Link to={`/profile/${username}`}><em>{username || 'guest'}</em></Link>!</span>
        <ul className={classes.buttons}>
          <li><Link to='/list_solo'>Solo</Link></li>
          {username && <li><Link to='/list_versus'>Versus</Link></li>}
          {!username && <li onClick={() => alert('You must be logged in to play Versus mode')} className={classes.disabled}>Versus</li>}
          <li><Link to='/challenges'>Challenges</Link></li>
          <li><Link to='/friends'>Friends</Link></li>
          <li><Link to='/leaderboards'>Leaderboards</Link></li>
          <li><Link to='/rules'>Rules</Link></li>
          <li onClick={this.logout} className={classes.inverse}>Logout</li>
        </ul>
        <Overlay />
      </div>
    )
  }
}

export const mapStateToProps = (state: any, ownProps: any): any => {
  return {
    username: state.username,
  }
}

export const mapDispatchToProps = (dispatch: Function, ownProps: any): any => {
  return {
    setUsername: (username) => dispatch(setUsername(username)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Homepage)



/** WEBPACK FOOTER **
 ** ./src/containers/Homepage/Homepage.js
 **/